import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const mergeEntities = (entities, options) =>
  defineAction(types.MERGE_ENTITIES, entities, options);

export const removeEntities = entities => defineAction(types.REMOVE_ENTITIES, entities);



// WEBPACK FOOTER //
// ./src/store/entities/actions.js